import { NormalizedCacheObject } from 'apollo-cache-inmemory'
import ApolloClient from 'apollo-client'

import { IgnoreSubscriptionsLink } from './IgnoreSubscriptionsLink'
import { MutationsTracker } from './MutationsTracker'
import { getShouldTrackMutationPredicates } from './shouldTrackMutationPredicates'
import {
  getIsMutationSuccessfulPredicates,
  subscriptionsToMutationsMap,
} from './subscriptionsMutationsMap'

export const createIgnoreSubscriptionsLink = (
  getClient: () => ApolloClient<NormalizedCacheObject> | undefined
) =>
  new IgnoreSubscriptionsLink({
    tracker: new MutationsTracker(),
    isMutationSuccessful: getIsMutationSuccessfulPredicates,
    shouldTrackMutation: getShouldTrackMutationPredicates(getClient),
    subscriptionsToMutationsMap,
  })
